export { default as SubTitleText } from "./SubTitleText";
export { default as ColoredText } from "./ColoredText";
export { default as HeadingColoredAndNormal } from "./HeadingColoredAndNormal";
export { default as DescriptionText } from "./DescriptionText";
export { default as ButtonWithArrow } from "./ButtonWithArrow";
export { default as AppButton } from "./AppButton";
